/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

export const frequencyPhraseKeys = {
  days: {
    times: {
      whole: 'frequency.timesDay.field.label',
      fraction: 'frequency.timesDay-fraction.field.label',
      range: 'frequency.timesDay-range.field.label',
    },
    every: {
      whole: 'frequency.everyDays.field.label',
      fraction: 'frequency.everyDays-fraction.field.label',
      range: 'frequency.everyDays-range.field.label',
    },
  },
  hours: {
    times: {
      whole: 'frequency.timesHour.field.label',
      fraction: 'frequency.timesHour-fraction.field.label',
      range: 'frequency.timesHour-range.field.label',
    },
    every: {
      whole: 'frequency.everyHours.field.label',
      fraction: 'frequency.everyHours-fraction.field.label',
      range: 'frequency.everyHours-range.field.label',
    },
  },
  months: {
    times: {
      whole: 'frequency.timesMonth.field.label',
      fraction: 'frequency.timesMonth-fraction.field.label',
      range: 'frequency.timesMonth-range.field.label',
    },
    every: {
      whole: 'frequency.everyMonths.field.label',
      fraction: 'frequency.everyMonths-fraction.field.label',
      range: 'frequency.everyMonths-range.field.label',
    },
  },
  weeks: {
    times: {
      whole: 'frequency.timesWeek.field.label',
      fraction: 'frequency.timesWeek-fraction.field.label',
      range: 'frequency.timesWeek-range.field.label',
    },
    every: {
      whole: 'frequency.everyWeeks.field.label',
      fraction: 'frequency.everyWeeks-fraction.field.label',
      range: 'frequency.everyWeeks-range.field.label',
    },
  },
  other: {
    asNeeded: 'frequency.other.asNeeded.name',
    continuously: 'frequency.other.continuously.name',
    once: 'frequency.other.once.name',
  },
};

function isOther(frequencyEnum) {
  switch (frequencyEnum.key) {
    case 'frequency.other.asNeeded.name':
    case 'frequency.other.continuously.name':
    case 'frequency.other.once.name':
      return true;
    default:
      return false;
  }
}

function isTimes(frequencyPhraseKey) {
  const keyString = frequencyPhraseKey || '';
  return keyString.indexOf('frequency.times') > -1;
}

function isFraction(frequencyData) {
  const keyString = frequencyData.value || '';
  return keyString.indexOf('.') > -1;
}

function isRange(frequencyData) {
  const keyString = frequencyData.value || '';
  return keyString.indexOf('-') > -1 || keyString.indexOf('—') > -1;
}

function getRangeOrFractionKey(frequencyEnum, frequencyData) {
  if (isOther(frequencyEnum)) {
    return frequencyEnum.key;
  }

  const groupKey = frequencyEnum.group || 'hours';
  const frequencyType = isTimes(frequencyEnum.key) ? 'times' : 'every';
  let frequencyNumber = 'whole';
  if (isRange(frequencyData)) {
    frequencyNumber = 'range';
  } else if (isFraction(frequencyData)) {
    frequencyNumber = 'fraction';
  }

  return _.get(frequencyPhraseKeys, `${groupKey}.${frequencyType}.${frequencyNumber}`, '');
}

function getFrequencyPhraseKey(groupKey, value, isTimesFrequency) {
  const frequencyType = isTimesFrequency ? 'times' : 'every';
  const frequencyData = { value };
  let frequencyNumber = 'whole';
  if (isRange(frequencyData)) {
    frequencyNumber = 'range';
  } else if (isFraction(frequencyData)) {
    frequencyNumber = 'fraction';
  }
  return _.get(frequencyPhraseKeys, `${groupKey}.${frequencyType}.${frequencyNumber}`, '');
}

function getPhraseData(frequencyEnum, frequencyData) {
  const id = getRangeOrFractionKey(frequencyEnum, frequencyData);
  const values = isRange(frequencyData) ? { string1: frequencyData.value } : { digit1: frequencyData.value };

  return {
    id,
    values,
  };
}

const Frequency = {
  isOther,
  isTimes,
  isFraction,
  isRange,
  getRangeOrFractionKey,
  getPhraseData,
  getFrequencyPhraseKey,
};

export default Frequency;
